module.exports = __webpack_public_path__ + "img/02-4解决方案.d7d43f9e.png";